import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { Frame } from '@photobooth/types';

export function useFrames(categoryId?: string) {
  const [frames, setFrames] = useState<Frame[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFrames = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const response = categoryId
        ? await api.frames.getByCategory(categoryId)
        : await api.frames.getAll();
        
      if (response.success && response.data) {
        // Handle nested data structure from API client
        const framesData = (response.data as any).data || response.data;
        setFrames(Array.isArray(framesData) ? framesData : []);
      } else {
        setError('Failed to fetch frames');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch frames');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFrames();
  }, [categoryId]);

  return {
    frames,
    isLoading,
    error,
    refetch: fetchFrames,
  };
}
